import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {MissingItemDataModel, MissingItemModel} from "../../models/missing-item.model";
import {ActionReasonEnum} from "../../../action-reasons/enums/action-reason.enum";
import {ActionReasonModel} from "../../../action-reasons/models/action-reason.model";

export class ServiceMissingItemTableRowComponent implements IController {
  data: MissingItemDataModel;
  index: number;
  quantityLeft: number;
  onRemove: Function;
  onChange: Function;
  form: any;

  public actionReasonTypes: ActionReasonEnum[];
  public selectedActionReason: ActionReasonModel;
  public quantityFieldName: string;
  public reasonFieldName: string;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.actionReasonTypes = [ActionReasonEnum.MissingItems];
    this.quantityFieldName = `quantity${this.index}`;
    this.reasonFieldName = `reason${this.index}`;

    if (this.data.reasonId) {
      this.selectedActionReason = {
        id: this.data.reasonId,
        reason: this.data.reason
      }
    }
  }

  $postLink() {
    this._setQuantityValidity();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.data && !changes.data.isFirstChange()) {
      if (!this.data.reasonId) {
        this.selectedActionReason = undefined;
      }
    }
    if (changes.quantityLeft && !changes.quantityLeft.isFirstChange()) {
      this._setQuantityValidity();
    }
  }

  onChangeQuantity(amount: number) {
    const dataCopy: MissingItemDataModel = angular.copy(this.data);
    dataCopy.quantity = amount;
    this.onChange({missingItemData: dataCopy});
  }

  onChangeActionReason(reason: ActionReasonModel) {
    this.selectedActionReason = reason;

    const dataCopy = angular.copy(this.data);
    dataCopy.reasonId = reason.id;
    dataCopy.reason = reason.reason;
    dataCopy.externalId = reason.externalId;
    dataCopy.description = reason.description;
    this.onChange({missingItemData: dataCopy});
  }

  private _setQuantityValidity() {
    this.form[this.quantityFieldName].$setValidity('valid', this.quantityLeft > -1);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceMissingItemTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      data: '<?',
      index: '<',
      quantityLeft: '<',
      onRemove: '&',
      onChange: '&',
    },
    template: require('./service-missing-item-table-row.html').default,
    controller: ServiceMissingItemTableRowComponent
  });
